<template>
  <InfuseModal
    :title="request?.messageAction ? request?.messageAction : '?'"
    :clickOutside="true"
    @close="$emit('close')"
  >
    <template #header>
      <div class="mt-2 flex gap-2">
        <InfuseTag v-if="request">{{ request.logDate }}</InfuseTag>
        <InfuseTag v-else-if="response">{{ response.logDate }}</InfuseTag>

        <InfuseTag v-if="request">{{ t('messageId') }}: {{ request.callId }} </InfuseTag>
        <InfuseTag v-else-if="response">{{ t('messageId') }}: {{ response.callId }} </InfuseTag>
      </div>
    </template>

    <p v-if="request" class="mt-2 text-xs text-neutral-700">{{ t('request') }}</p>
    <InfuseJsonCodeBlock v-if="request" class="mt-2" :payload="request.message" />

    <p v-if="response" class="mt-2 text-xs text-neutral-700">{{ t('response') }}</p>
    <InfuseJsonCodeBlock v-if="response" class="mt-2" :payload="response.message" />

    <p v-if="request && request.messageType === MessageType.FIRE_AND_FORGET" class="mt-2 text-xs text-neutral-700">
      {{ t('response') }}
    </p>
    <InfuseNote v-if="request && request.messageType === MessageType.FIRE_AND_FORGET" type="info">
      {{ t('fireAndForget') }}
    </InfuseNote>
  </InfuseModal>
</template>

<script lang="ts" setup>
import { MessageType, ServerLog } from '@infuse/cpms/charging-station/store';
import { InfuseJsonCodeBlock, InfuseModal, InfuseNote, InfuseTag } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Props {
  request?: ServerLog;
  response?: ServerLog;
}

interface Emits {
  (e: 'close'): void;
}

defineProps<Props>();
defineEmits<Emits>();
</script>

<i18n>
{
  "en": {
    "messageId": "Message ID",
    "request": "Request",
    "response": "Response",
    "fireAndForget": "Fire and forget never has a response."
  },
  "nl": {
    "messageId": "Bericht-ID",
    "request": "Request",
    "response": "Response",
    "fireAndForget": "Fire & forget heeft nooit een response."
  }
}
</i18n>
